// Copyright (c) 2020 Deere & Company

import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import rgaSearchModel from './rga-search';
import rgaSearchSelectedDomains from './rga-domain-values';
import searchByDropDown from './search-by-dropdown';
import searchQueryString from './search-query-string';

export const getCombinedReducers = () => combineReducers({
    busyCounter,
    rgaSearchModel,
    rgaSearchSelectedDomains,
    searchByDropDown,
    searchQueryString
});



// WEBPACK FOOTER //
// ./src/rga/search/reducers/index.js